module.exports = __webpack_public_path__ + "img/icon-one-store.97e7646d.png";